import { IonContent, IonPage } from "@ionic/react";
import Header from "../Header/System";
import Navigation from "../Navigation";
import { SystemLayoutProps } from "./types";

const Layout: React.FC<SystemLayoutProps> = ({
    header = true,
    children,
    system,
    sidebar,
    statusbar,
    navbar,
    backbutton,
    id = ''
}) =>
{
    return <>
        {header ? <Header id={(system?.systemNumber || "") + ""} backbutton={backbutton} title={'PriceList'} /> : false}
        <Navigation sidebar={sidebar} statusbar={statusbar} navbar={navbar} id={id} hasHeader={header}>
            <IonPage>
                <IonContent fullscreen>
                    {children}
                </IonContent>
            </IonPage>
        </Navigation>
    </>;
};

export default Layout;